const matrixMap = {
  pb_solving_score: {
    A: {
      min: 100,
      max: 100,
    },
    B: {
      min: 88.88,
      max: 99.99,
    },
    C: {
      min: 77.77,
      max: 88.87,
    },
    D: {
      min: 66.66,
      max: 77.76,
    },
    E: {
      min: 0,
      max: 66.65,
    },
  },
  default: {
    A: {
      min: 80,
      max: 100,
    },
    B: {
      min: 60,
      max: 79.99,
    },
    C: {
      min: 40,
      max: 59.99,
    },
    D: {
      min: 20,
      max: 39.99,
    },
    E: {
      min: 0,
      max: 19.99,
    },
  },
};

function getRankLevels(module, calibration) {
  return Object.entries(calibration.softskills[module]).filter(
    ([key]) => key !== "min" && key !== "max"
  );
}

function getModuleRank(note, version, module, calibration, isV2_1 = false, isV2_1_2 = false) {
  if (note === -1) return { rank: "", value: 0 };
  if (version === 1) {
    const rankObject = getRankLevels(module, calibration).find(
      ([, value]) => value <= note
    );

    return rankObject
      ? { rank: rankObject[0], value: rankObject[1] }
      : {
        rank: "E",
        value: calibration.softskills[module].min,
      };
  } else {

    const matrix = (isV2_1 || isV2_1_2) ? matrixMap.default : (matrixMap[module] ?? matrixMap.default);

    const [rank] = Object.entries(matrix).find(([, zone]) => zone.min <= note);

    return { rank, value: note };
  }
}

function getInferiorModuleRank(note, version, module, calibration) {
  const currentRank = getModuleRank(note, version, module, calibration);

  const rankIndex = getRankLevels(module, calibration).findIndex(
    ([rank]) => rank === currentRank.rank
  );

  if (rankIndex + 2 >= Object.keys(matrixMap.default).length) {
    return {
      rank: "E",
      value: calibration.softskills[module].min,
    };
  } else {
    const ranks = Object.keys(matrixMap.default);

    return {
      rank: ranks[rankIndex + 1],
      value: calibration.softskills[module][ranks[rankIndex + 1]],
    };
  }
}

function getSuperiorModuleRank(note, version, module, calibration) {
  const currentRank = getModuleRank(note, version, module, calibration);

  const rankIndex = getRankLevels(module, calibration).findIndex(
    ([rank]) => rank === currentRank.rank
  );

  if (rankIndex === 0) {
    return {
      rank: "A",
      value: calibration.softskills[module].max,
    };
  } else {
    const ranks = Object.keys(matrixMap.default);

    return {
      rank: ranks[rankIndex - 1],
      value: calibration.softskills[module][ranks[rankIndex - 1]],
    };
  }
}

function computeModuleScore(note, version, module, calibration, isV2_1 = false, isV2_1_2 = false) {
  if (version === 2) return note;

  const [absInfLevel, absSupLevel] = [
    getInferiorModuleRank(note, version, module, calibration).value,
    getSuperiorModuleRank(note, version, module, calibration).value,
  ];

  const { min: relInfLevel, max: relSupLevel } =
    matrixMap.default[getModuleRank(note, version, module, calibration, isV2_1, isV2_1_2).rank];

  const coefFormula = (note - absInfLevel) / (absSupLevel - absInfLevel);

  const coef = isNaN(coefFormula) ? 0 : coefFormula;

  const score = relInfLevel + (relSupLevel - relInfLevel) * coef;

  return score;
}

export { getModuleRank, computeModuleScore };
